import { useNavigate } from '@tanstack/react-router'
import type { AxiosError } from 'axios'
import mccLogo from '@/assets/mcc_logo.png'
import { Container } from '@/components/Container'
import { Button } from '@/components/ui/button'

export function InvalidTokenMessage({
  error,
  type,
}: {
  error: Error
  type: 'setup' | 'reset'
}) {
  const navigate = useNavigate()

  const rawMessage =
    (error as AxiosError<{ message: string }>).response?.data.message || ''
  let message = 'Your setup link is invalid or expired'
  let details = ''

  if (rawMessage.includes('No token provided')) {
    message = 'No setup token was provided'
    details = `Please use the link from your email or request a new ${type === 'reset' ? 'password reset' : 'setup'} email.`
  } else if (rawMessage.includes('Invalid or expired setup link')) {
    message = 'Your setup link is invalid or expired'
    details = `The link may have already been used or is no longer valid. ${type === 'setup' ? 'Please request a new setup email.' : 'Please request a new password reset email.'}`
  } else if (rawMessage.includes('Setup link expired')) {
    message = 'Your setup link has expired'
    details = `Setup links are only valid for 1 hour. ${type === 'setup' ? 'Please request a new setup email.' : 'Please request a new password reset email.'}`
  } else if (rawMessage) {
    message = rawMessage
  }

  return (
    <Container>
      <div className="flex flex-col items-center gap-6 text-center">
        <img
          src={mccLogo}
          alt="Maranatha Christian Church"
          className="w-48 sm:w-52"
        />
        <div className="w-full max-w-sm rounded-lg border bg-white p-6 shadow-sm">
          <h1 className="mb-4 text-xl font-semibold">{message}</h1>
          {details && (
            <div className="mb-4 text-sm text-neutral-700">{details}</div>
          )}
          <Button className="w-full" onClick={() => navigate({ to: '/login' })}>
            Go to Login
          </Button>
        </div>
      </div>
    </Container>
  )
}
